module.exports = __webpack_public_path__ + "static/media/Teeth_alignment_modelling_external.d7723385.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/Teeth_alignment_modelling_external.svg
// module id = 942
// module chunks = 0